import script from "./PopperActionLocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopperActionLocation.vue?vue&type=script&setup=true&lang=ts"

import "./PopperActionLocation.vue?vue&type=style&index=0&id=09055a27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09055a27"]])

export default __exports__